import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _colors;
import { EDatasetColors } from '../types/public';
export var colors = (_colors = {
  TRANSPARENT: 'transparent',
  GRAY_06: 'rgba(21, 34, 66, 0.06)',
  GRAY_10: 'rgba(21, 34, 66, 0.1)',
  GRAY_40: 'rgba(21, 34, 66, 0.4)'
}, _defineProperty(_colors, EDatasetColors.RED, {
  '0': 'rgba(255,31,52, 0)',
  '24': 'rgba(255,31,52, 0.24)',
  '100': 'rgba(255,31,52, 1)'
}), _defineProperty(_colors, EDatasetColors.BLUE, {
  '0': 'rgba(4, 104, 255, 0)',
  '24': 'rgba(4, 104, 255, 0.24)',
  '100': 'rgba(4, 104, 255, 1)'
}), _defineProperty(_colors, EDatasetColors.ORANGE, {
  '0': 'rgba(255, 126, 0, 0)',
  '24': 'rgba(255, 126, 0, .24)',
  '100': 'rgba(255, 126, 0, 1)'
}), _colors);